import { Pages } from "./types";

export const enum AnalyticsPageUserGuides {
  UserGuides = "UserGuides",
}

export const pagesUserGuides: Pages<AnalyticsPageUserGuides> = {
  [AnalyticsPageUserGuides.UserGuides]: ["User Guides"],
};
